const StatsAfterSalesNoticeRecord = () => import('@/views/main/afterSalesNoticeRecord/stats/index.vue')
export default {
  path: '/main/afterSalesNoticeRecord/stats',
  name: 'StatsAfterSalesNoticeRecord',
  component: StatsAfterSalesNoticeRecord,
  children: []
}
